module.exports = __webpack_public_path__ + "static/leo-lg(BW)-5fbcd0a41c87c2f4ad29a8829163ad78.jpg";